import { Routes } from '@angular/router';
import { Home } from './page/home/home';
import { Documents } from './views/documents/documents';
import { WebSites } from './views/web-sites/web-sites';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    children: [
      {
        path: ':indexName/documents/:tab',
        component: Documents,
      },
      {
        path: ':indexName/documents',
        redirectTo: ':indexName/documents/to-process',
        pathMatch: 'full',
      },
      {
        path: ':indexName/web-sites',
        component: WebSites,
      },
      {
        path: ':indexName',
        redirectTo: ':indexName/documents/to-process',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];